module.exports = __webpack_public_path__ + "img/icone-relatorio.2d0a9435.svg";